<template>
  <div class="index-parent">
    <div class="index">
      <div class="title">您可以在下面分类中找到我们所有的商品</div>
      <div class="category-split">——</div>
      <div class="nav">
        <el-popover
          placement="bottom-start"
          trigger="hover"
          v-for="item in items"
          v-bind:key="item.name"
          class="item"
          transition="el-collapse-transition"
        >
          <ProductCategorySecondMenu :items="item.children" @selected="onCategoryCode" />
          <span slot="reference" @click="onCategoryCode(item.code)">
            <el-badge :value="item.count" :max="99" :title="item.count" >
              <img :src="util.getImageUrl(item.icon)" title="" />
            </el-badge>
             <div>{{item.name}}</div>
         </span>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
import ProductCategorySecondMenu from "./ProductCategorySecondMenu.vue";

export default {
  name: "ProductCategoryHorizontalSelect",
  components: {
    ProductCategorySecondMenu
  },
  computed: {
    items() {
      return this.$store.getters.getProductCategoryOptions();
    }
  },
  methods: {
    onSelected(code) {
      this.current = this.$store.getters.getProductCategoryOptionsByCode(code);
    },
    onCategoryCode(code) {
      this.$emit("selected", code);
    }
  }
};
</script>

<style lang="less" scoped>
.index-parent {
  width: 100%;
  background: rgba(252, 252, 252, 1);
}
.index {
  width: 1100px;
  margin: 0 auto;
  // background-image: linear-gradient(to top, #ffffff, #f0f0f0);
  padding: 20px 0 60px 0;

  .title {
    font-size: 20px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 28px;

    text-align: center;
  }

  .category-split {
    color: #848791;
    text-align: center;
    margin: 10px;
  }

  .nav {
    .item {
      display: inline-block;
      width: 120px;
      margin-right: 20px;

      text-align: center;

      font-weight: bold;

      /*background: rgba(252, 252, 252, 1);*/

      cursor: pointer;

      img {
        width: 100px;
        height: 100px;
        background: linear-gradient(
          137deg,
          rgba(255, 255, 255, 1) 0%,
          rgba(207, 207, 207, 1) 100%
        );
        border-radius: 50%;
      }

      div {
        margin-top: 10px;
        font-size: 15px;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 21px;
      }
    }
    .item:last-child {
      margin-right: 0;
    }
    .item:hover {
      img {
        width: 96px;
        height: 96px;
        border: 2px solid #40b15d;
      }
      div {
        color: #1b994f;
      }
    }
  }
  .collapse {
    background: #3a8b65;

    color: white;

    .item {
      display: inline-block;
      margin: 0 10px;
    }
  }
}
</style>

